import styled from 'styled-components';

export const InfoContainer = styled.div`
    display: flex;
    justify-content: center;

    .period-header {
        display: flex;
        flex-direction: column;
        align-items: start;
        margin-top: -15px;
    }
`;

export const TotalContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;

    .counter-card {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border: 5px solid ${props => props.theme.palette.primary.main};

        .card-heading {
            color: ${props => props.theme.palette.primary.main};
        }

        .value {
            font-weight: bold;
            font-size: 42px;
            color: ${props => props.theme.palette.primary.main};
        }
    }
`;

export const DetailField = styled.div`
    display: flex;
    flex-direction: ${props => (props.column ? 'column' : 'row')};
    gap: ${props => (props.column ? '8px' : '12px')};
    margin-bottom: 16px;

    strong {
        min-width: ${props => (props.column ? 'auto' : '140px')};
        flex-shrink: 0;
    }

    span {
        word-break: break-word;
    }
`;

export const JsonBlock = styled.pre`
    background: ${props => (props.dark ? '#2d2d2d' : '#f5f5f5')};
    color: ${props => (props.dark ? '#f5f5f5' : '#333')};
    padding: 12px;
    border-radius: 4px;
    overflow: auto;
    max-height: 320px;
    font-size: 12px;
    line-height: 1.5;
    white-space: pre-wrap;
    word-break: break-word;
    margin: 0;
    width: 100%;
    border: 1px solid ${props => (props.dark ? '#444' : '#ddd')};
`;

export const TableArea = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .card-title {
        font-weight: bold;
    }

    tbody {
        display: block;
        min-height: 150px;
        max-height: 250px;
        overflow-y: auto;

        ::-webkit-scrollbar {
            width: 5px;
        }

        ::-webkit-scrollbar-track {
            background: #f1f1f1;
        }

        ::-webkit-scrollbar-thumb {
            background: #888;
        }

        ::-webkit-scrollbar-thumb:hover {
            background: #555;
        }
    }

    thead,
    tbody tr {
        display: table;
        width: 100%;
        table-layout: fixed;

        .col-sm {
            width: 15%;
            max-width: 100px;
        }
    }
`;
